// @core/api/endpoints/secret/create_pki_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePkiRoleRequest,
  PkiRoleResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Create PKI role
 * Creates a certificate issuance role that defines constraints (allowed domains, key types, TTLs) for certificates issued under this role.
 */
export async function CreatePkiRole(
  engine_id: string,
  data: CreatePkiRoleRequest,
  options?: RequestOptions
): Promise<PkiRoleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/roles`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.post<PkiRoleResponse>(requestPath, data, requestOptions);
}
